import { ClassGroupsPage } from 'pages/ClassGroups';
import { appRouterPaths } from 'services/navigation';
import type { AppRouteProps } from '../types';

export const classGroupsPageRoute: AppRouteProps = {
  path: appRouterPaths.classGroups,
  element: <ClassGroupsPage />,
};
